import { Pipe, PipeTransform } from '@angular/core';
import { Timestamp } from '@angular/fire/firestore';

@Pipe({
  name: 'timestampToDate',
  standalone: true,
})
export class TimestampToDatePipe implements PipeTransform {
  transform(timestamp: Timestamp | undefined): Date | null {
    if (timestamp && timestamp.seconds) {
      const date = new Date(timestamp.seconds * 1000);

      return date;
    }
    return null;
  }
}
